export default __webpack_public_path__ + "static/media/01-small.fbc7f0e5.jpg";